<template>
  <div class="scroll">
    <UseTermsKo v-if="language === 'ko'" />
    <UseTermsEn v-else />
  </div>
</template>

<script>
import UseTermsKo from './UseTermsKo.vue'
import UseTermsEn from './UseTermsEn.vue'

export default {
  components: {
    UseTermsKo,
    UseTermsEn
  },
  data() {
    return {
      language: localStorage.getItem('defaultLanguage').substring(0, 2) || 'ko'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/join/modal/UseTerms.vue